import React from 'react'

import '../css/Footer.css'

export default function Footer() {
  return (
    <footer id="main-footer">
      <div id="footer-columns">
        <div>
          <h3>Help</h3>
          <a href="/register">Register Volunteer</a>
          <a href="/sponsor">Sponsor a child</a>
          <a href="/donate">Donate</a>
        </div>

        <div>
          <h3>Contact Us</h3>
          <span>Address: Bole Sub City, Woreda 03, Babo Building, 4th Floor</span>
          <span>Phone 1: +0116894040</span>
          <span>Phone 2: +0911227544</span>
          <span>Email: <a href="mailto:enehofikir@outlook.com">enehofikir@outlook.com</a></span>
        </div>
      </div>

      <section>Copyright © Eneho Fiker 2019. All Rights Reserved.</section>
    </footer>
  )
}